const chunkMapping = {
	"webpack_container_remote_AtomCommonApp_HeaderModule": [
		"webpack/container/remote/AtomCommonApp/HeaderModule"
	],
	"webpack_container_remote_AtomCommonApp_AtomMobileHeader": [
		"webpack/container/remote/AtomCommonApp/AtomMobileHeader"
	],
	"webpack_container_remote_AtomCommonApp_AtomMobileSidebar": [
		"webpack/container/remote/AtomCommonApp/AtomMobileSidebar"
	]
};
const idToExternalAndNameMapping = {
	"webpack/container/remote/AtomCommonApp/HeaderModule": [
		"default",
		"./HeaderModule",
		"webpack/container/reference/AtomCommonApp"
	],
	"webpack/container/remote/AtomCommonApp/AtomMobileHeader": [
		"default",
		"./AtomMobileHeader",
		"webpack/container/reference/AtomCommonApp"
	],
	"webpack/container/remote/AtomCommonApp/AtomMobileSidebar": [
		"default",
		"./AtomMobileSidebar",
		"webpack/container/reference/AtomCommonApp"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}